import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const CustomerTestimonials: React.FC = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 'alexis-dewpoint',
      name: 'Alexis Isabettini',
      location: 'Argentina',
      equipment: 'DewPoint 6210 System',
      testimonialKey: 'testimonials.alexis',
    }
  ];

  return (
    <section className="py-16 bg-white/50 dark:bg-black/30">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-accent">
            {t('testimonials.title')}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </motion.div>

        <div className="flex justify-center">
          <div className="max-w-md w-full">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.id}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="bg-white/80 dark:bg-black/60 rounded-xl shadow-lg p-6 border border-gray-200 dark:border-gray-700"
              >
                {/* Testimonial Quote */}
                <div className="mb-6">
                  <div className="text-accent text-4xl mb-2">"</div>
                  <p className="text-gray-700 dark:text-gray-300 italic leading-relaxed">
                    {t('testimonials.alexis.quote')}
                  </p>
                  <div className="text-accent text-4xl text-right">"</div>
                </div>

                {/* Customer Info */}
                <div className="border-t border-gray-200 dark:border-gray-600 pt-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mr-4">
                      <span className="text-accent font-bold text-lg">A</span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-gray-900 dark:text-white">
                        Alexis Isabettini
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        Argentina
                      </p>
                      <p className="text-sm text-accent font-medium">
                        DewPoint 6210 System
                      </p>
                    </div>
                  </div>
                </div>

                {/* Savings Highlight */}
                <div className="mt-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-3">
                  <div className="text-xs text-green-700 dark:text-green-300 font-semibold text-center">
                    {t('testimonials.alexis.savings')}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerTestimonials;
